import React from "react";
import clsx from "clsx";

import ToggleSwitch from "./ToggleSwitch";

const CategoryRow = ({ item, onToggle, onWeightChange, showDivider }) => {
  const isDisabled = !item.is_active;

  return (
    <>
      <div className="category-row">
        <div className="category-row__name">{item.label}</div>

        <div className="category-row__toggle">
          <ToggleSwitch
            checked={item.is_active}
            onChange={() => onToggle(item.metrics)}
          />
        </div>

        <div className="category-row__weight">
          <div
            className={clsx(
              "weight-input-wrapper",
              isDisabled && "weight-input-wrapper--disabled"
            )}
          >
            <input
              type="number"
              min="0"
              max="100"
              value={item.weight_percent ?? ""}
              placeholder="Enter Amount..."
              disabled={isDisabled}
              onChange={(event) => {
                event.preventDefault();
                const value = event.target.value;
                if (value === "") {
                  onWeightChange(item.metrics, "");
                  return;
                }

                const parsed = Math.min(
                  100,
                  Math.max(0, parseInt(value, 10) || 0)
                );
                onWeightChange(item.metrics, String(parsed));
              }}
              onWheel={(event) => event.currentTarget.blur()}
              className="weight-input"
            />
            <span className="weight-input__suffix">%</span>
          </div>
        </div>
      </div>

      {showDivider && <div className="table-divider" />}
    </>
  );
};

export default CategoryRow;
